
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cotd",
      function () {
        return require("private-next-pages/cotd.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cotd"])
      });
    }
  